function readRequiredUrl(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(`${name} is required`);
  }

  let parsed: URL;
  try {
    parsed = new URL(value);
  } catch {
    throw new Error(`${name} must be a valid absolute URL`);
  }

  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
    throw new Error(`${name} must use http or https`);
  }

  if (parsed.username || parsed.password || parsed.search || parsed.hash) {
    throw new Error(
      `${name} cannot contain credentials, a query string, or a fragment`,
    );
  }

  return value.replace(/\/+$/, '');
}

const configuredEscalationEmail = import.meta.env.VITE_ESCALATION_EMAIL?.trim();

export const environment = Object.freeze({
  apiBaseUrl: readRequiredUrl(
    'VITE_API_BASE_URL',
    import.meta.env.VITE_API_BASE_URL,
  ),
  escalationEmail:
    configuredEscalationEmail && configuredEscalationEmail.length > 0
      ? configuredEscalationEmail
      : 'admin@marina.com',
});
